import React from 'react';

export default {
  tiles: [
    {
      id: 0,
      copy: (
        <React.Fragment>
          <strong>
            What Are Community Development Financial Institutions (CDFIs)?
          </strong>
          <br />
          <br />
          CDFIs are banks and credit unions that accommodate people who are
          traditionally locked out of financial systems.
        </React.Fragment>
      ),
      image:
        'https://www.nerdwallet.com/cdn/landing-pages/employee-brand-lpc/CSR+Article+1+Image.png',
      isNarrow: true,
      linkUrl:
        'https://www.nerdwallet.com/article/banking/what-is-community-development-financial-institution-cdfi',
      linkCopy: 'Learn more >',
    },
    {
      id: 1,
      copy: (
        <React.Fragment>
          <strong>Second Chance Checking Accounts Across the U.S.</strong>
          <br />
          <br />
          Second chance checking is an option if you&apos;ve been rejected for{' '}
          an account due to a bad banking history. Accounts are available in all{' '}
          50 states.
        </React.Fragment>
      ),
      image:
        'https://www.nerdwallet.com/cdn/landing-pages/employee-brand-lpc/CSR+Article+2+Image.png',
      isNarrow: true,
      linkUrl:
        'https://www.nerdwallet.com/article/banking/second-chance-checking',
      linkCopy: 'Learn more >',
    },
  ],
};
